import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { Router, ActivatedRoute } from '@angular/router';
import { Lead } from 'src/app/core/interfaces/lead/lead';
import { ApiService } from 'src/app/core/services/api/api.service';
import { DatePipe } from '@angular/common';
import { ExcelExportComponent } from '@progress/kendo-angular-excel-export';

@Component({
  selector: 'app-lead-count-list',
  templateUrl: './lead-count-list.component.html',
  styleUrls: ['./lead-count-list.component.scss'],
})
export class LeadCountListComponent implements OnInit {
  @Input() status: string;
  statusMessage: string;
  statusNumber: number;

  displayedColumns: string[] = [];

  noDispoDisplayedColumns: string[] = [
    'company_Code',
    'customer',
    'phone',
    'leadTypeName',
    'lastContacted',
    'createdDate',
    'leadSubSourceName',
    'updatedBy',
    'updatedDate',
    'jobAddress',
    'zoneName',
  ];

  dispoDisplayedColumns: string[] = [
    'company_Code',
    'customer',
    'phone',
    'leadTypeName',
    'createdDate',
    'updatedBy',
    'updatedDate',
    'jobAddress',
    'zoneName',
    'estimator',
    'dispositionName',
    'subDispositionName',
    'dispositionNotes',
  ];

  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;
  @ViewChild('excelexport') excelexport: ExcelExportComponent;

  leadArray: Lead[] = [];
  dataSource: MatTableDataSource<Lead>;

  isLoading: boolean = true;
  excelFileName: string;

  constructor(
    private apiService: ApiService,
    private router: Router,
    private route: ActivatedRoute,
    public datePipe: DatePipe
  ) {}

  ngOnInit(): void {
    this.isLoading = true;
    this.dataSource = new MatTableDataSource();
    let currentDate = this.datePipe.transform(new Date(), 'MM-dd-yyyy');
    this.excelFileName = `Lead_Count_${currentDate}.xlsx`;
    // this.getLeads(this.status);
    this.route.paramMap.subscribe((params) => {
      this.isLoading = true;
      this.status = params.get('status') as string;
      this.getLeads(this.status);
    });
  }

  getLeads(status: string) {
    this.isLoading = true;
    this.dataSource = new MatTableDataSource();

    if (status) {
      switch (status) {
        case 'pending':
          this.statusNumber = 0;
          this.statusMessage = 'Pending leads to schedule';
          this.displayedColumns = this.noDispoDisplayedColumns;
          break;
        case 'resets':
          this.statusNumber = 1;
          this.statusMessage = 'Resets to schedule';
          this.displayedColumns = this.dispoDisplayedColumns;
          break;
        case 'revisits':
          this.statusNumber = 2;
          this.statusMessage = 'Revisits to schedule';
          this.displayedColumns = this.dispoDisplayedColumns;
          break;
        case 'reschedule':
          this.statusNumber = 3;
          this.statusMessage = 'Leads to reschedule';
          this.displayedColumns = this.dispoDisplayedColumns;
          break;
        case 'pendingDead':
          this.statusNumber = 7;
          this.statusMessage = 'Pending dead leads';
          this.displayedColumns = this.noDispoDisplayedColumns;
          break;
      }
    }

    if (this.statusNumber != undefined) {
      this.apiService.getLeadsByStatus(this.statusNumber).subscribe({
        next: (response) => {
          // console.log('Leads fetched successfully:', response);
          this.isLoading = false;
          this.leadArray = response;
          this.dataSource = new MatTableDataSource(this.leadArray);
          this.dataSource.sort = this.sort;
          this.dataSource.paginator = this.paginator;
        },
        error: (e) => {
          this.isLoading = false;
          console.error(e);
        },
      });
    }
  }

  goToLead(row: Lead) {
    if (this.statusNumber === 7) {
      this.router.navigate(['customers/' + row.customerId], {
        queryParams: {
          jobAddressId: row.jobAddressId,
          pendingDeadLeadId: row.leadId,
        },
      });
    } else {
      this.router.navigate(['generate-lead/step2'], {
        queryParams: {
          customerid: row.customerId,
          jobaddressid: row.jobAddressId,
          leadid: row.leadId,
        },
      });
    }
  }

  filterLeads(event: Event) {
    const filterString = (event.target as HTMLInputElement).value;
    this.dataSource.filter = filterString.trim().toLowerCase();
  }

  getLeadColumns(): string[] {
    return this.displayedColumns;
  }

  exportToExcelFile(exportComponent: ExcelExportComponent) {
    const options = exportComponent.workbookOptions();
    const rows = options.sheets?.[0].rows;

    if (rows && rows.length > 0) {
      rows.forEach((row) => {
        if (row.type === 'data') {
          row.cells?.forEach((cell) => {
            if (cell.value) {
              const isDate = !isNaN(Date.parse(cell.value as string));
              if (this.isJustNumeric(cell.value as string)) {
                cell.format = '0.00';
                cell.value = Number(cell.value);
              } else if (isDate) {
                cell.format = 'mm-dd-yyyy';
              }
            }
          });
        }
      });
    }

    exportComponent.save(options);
  }

  isJustNumeric(value: string): boolean {
    return /^\d+(\.\d+)?$/.test(value);
  }
}
